"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonText = exports.LabelContainer = exports.ButtonContainer = exports.StyledTwisterButton = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const themed_text_1 = require("../../themed-text");
const setBorderStyle = (props) => {
    const borderStyle = props.isValid ? 'solid' : 'dashed';
    const borderColor = props.selected ? '#e77600' : '#a2a6ac';
    return (0, styled_components_1.css) `
    border: 1px ${borderStyle} ${borderColor};
  `;
};
const setColor = (props) => {
    return (0, styled_components_1.css) `
    color: ${props.isValid ? props.theme.palettes.font.primary : '#CCC'};
  `;
};
exports.StyledTwisterButton = styled_components_1.default.button `
  padding: 5px 10px 5px 11px;
  border-radius: 0;
  background-color: transparent;
  width: fit-content;
  ${setBorderStyle};
  ${setColor};
  &:hover {
    background-color: #f7fafa;
    color: ${(props) => props.theme.palettes.font.primary};
  }
  &:focus {
    box-shadow: 0 0 3px 2px rgb(228 121 17 / 50%);
  }
  position: relative;
`;
exports.ButtonContainer = styled_components_1.default.div `
  display: flex;
  column-gap: 5px;
  flex-flow: wrap;
  width: 100%;
  row-gap: 5px;
`;
exports.LabelContainer = styled_components_1.default.div `
  display: inline;
  padding: 8px 0 6px 0;
`;
exports.ButtonText = (0, styled_components_1.default)(themed_text_1.ThemedSpan) `
  font-size: 14px;
  color: inherit;
`;
